<template>
  <div class="title-wrap">
    <div class="left">
      <div class="title">
        <span>{{ title }}</span>
      </div>
      <span v-if="description">{{ description }}</span>
    </div>
    <div class="right"><slot name="right"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'detail-page-title',
  props: {
    title: String,
    description: String
  }
}
</script>

<style lang="scss" scoped>
.title-wrap {
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #d7d7d7;
  overflow: hidden;
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
  .title {
    display: inline-block;
    font-size: 14px;
    color: #606060;
    &::before {
      display: inline-block;
      content: '';
      height: 14px;
      width: 4px;
      background: #409bff;
      margin-right: 6px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail-page/title.vue